<template>
  <el-switch
      ref="gjSwitch"
      v-bind="$attrs"
      v-on="$listeners"
      :class="[`gj-switch--${size}`]">
  </el-switch>
</template>

<script>

  export default {
    name: "gj-switch",
    props: {
      size: {
        type: String,
        default: 'default',
        validator: function (value) {
          return ['default', 'small'].indexOf(value) !== -1
        }
      },
    }
  }
</script>

<style scoped lang="scss">
.el-switch{
  line-height: 22px;
  height: 22px;
  /deep/ .el-switch__core {
    height: 22px;
    border-radius: 11px;
    border: 1px solid #E4E5E6;
    background: #E4E5E6;
  }
  /deep/ .el-switch__core:after {
    width: 18px;
    height: 18px;
  }
  /deep/ .el-switch__label{
    font-size: 12px;
    span{
      font-size: 12px;
    }
  }
}
.el-switch.is-checked /deep/ .el-switch__core{
  border: 1px solid #1F6EEF;
  background: #1F6EEF;
}
.el-switch.is-checked /deep/ .el-switch__core::after{
  margin-left: -19px;
}

  .gj-switch--small /deep/ .el-switch__core:after {
    width: 12px;
    height: 12px;
  }
  .el-switch.is-checked.gj-switch--small /deep/ .el-switch__core::after {
    margin-left: -13px;
  }
  .gj-switch--small /deep/ .el-switch__core {
    height: 16px;
    width: 30px !important;
    line-height: 16px;
  }
</style>
